import useTranslator from "../../hooks/useTranslator";
import DocIcon from "../../assets/img/DocIcon.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import noticIcon from "../../assets/img/noticIcon.svg";
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import constants from "../../Utils/constants";
import docsData from "../../Utils/docsData";
import TenantContext from "../../context/tenant/TenantContext";
import moment from "moment";
import {
  isClientIdentificationActive,
  haveValue,
  removeUuidFromFileName,
  toast,
  getKycCustomMessage,
  isCompanyTenantOwnDocument,
  getEmploymentDocsMissing,
} from "../../helper/common";
import DocHistoryPopup from "../Property/DocHistoryPopup";
import DotIcon from "../../assets/img/DotIcon.svg";
import DocUploadingComponentWithAnalysing from "../Tenant/DocUploadingComponentWithAnalysing";
import DeleteConfirationForDoc from "./DeleteConfirmationForDoc";
import {
  dea_missing_docs,
  docsMap,
  forensic_docs_map,
} from "../../Utils/skorLiteDocumentMap";
import { Badge, Button, Icon, SkeletonList, Tabs } from "../design";
import "./detailsDocs.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import AuthContext from "../../context/auth/AuthContext";
import {
  OtherDocsSection,
  ProtectedHousingSection,
  IdentificationSection,
  EmploymentStatusSection,
  IncomeTaxesSection,
  ScannedTooltip,
  MissingDocTooltip,
  WarningTooltip,
  HighRiskTooltip,
  NoDocumentsFound,
  STATUS_ICONS,
} from "./DocumentSection";
import ViewMissingDocNoteButton from "./ViewMissingDocNoteButton";
import MissingDocNoteFooter from "./MissingDocNoteFooter";
import LandlordNotePillButton, {
  LANDLORD_MISSING_DOC_NOTE_BOX_ID,
  getMissingDocRowAnchorId,
} from "./LandlordNotePillButton";
import MissingDocumentsNoteModal from "./MissingDocumentsNoteModal";
import LandlordMissingDocNoteBox from "./LandlordMissingDocNoteBox";
import {
  getExplainedDocCanonicalKeys,
  isMissingDocExplained,
  canonicalizeMissingDocKey,
  isIdentityDocumentKey,
  filterStillMissingNoteEntries,
} from "../../Utils/missingDocNote";
import {
  getDocOwnerLabel,
  isDocOwnedByOtherPerson,
} from "../../Utils/tenantDocOwnership";
import {
  DOCUMENT_CATEGORIES,
  DOCUMENT_CATEGORY_CONFIG,
} from "../../Utils/document-categories";
import {
  PAYSLIP_ORDER,
  countFilledPayslipSlots,
  isThreePayslipEmploymentStatus,
} from "../../Utils/payslipRequirement";
import { isSkorSdkSearch } from "../../helper/skorSdk";
import { isClientIdentificationPending } from "../Profiles/ClientIdentificationStatus";
import { getLatestKycServiceFiles } from "../../Utils/serviceFileTags";
import { applyRetaSlotTypes, RETA_ORDER } from "../../Utils/retaRequirement";
import {
  TENANT_DOCUMENT_NAVIGATION_EVENT,
  documentMatchesIdentifiers,
  getServiceFileDocumentIdentifiers,
  getTenantDocumentIdentifiers,
} from "../../Utils/tenantDocumentNavigation";

const ANALYSIS_POLL_INTERVAL_MS = 15000;
const ANALYSIS_MAX_POLL_ATTEMPTS = 40;
const ANALYSIS_MAX_CONSECUTIVE_ERRORS = 3;

// Company login tenants: occupants' documents are shown only per occupant
// (occupants side panel), never in the main Documents card.
const withoutOccupantDocs = (docs) =>
  (docs ?? []).filter((doc) => doc?.type !== constants.OCCUPANT_ID_PROOF);

// Company login tenants: document groups of their map (skorLiteDocumentMap
// COMPANY_TENANT_DOCS) and the analysis categories each one also matches.
const COMPANY_INCOME_CATEGORIES = [
  DOCUMENT_CATEGORIES.TAX,
  DOCUMENT_CATEGORIES.INCOME,
  DOCUMENT_CATEGORIES.PAYMENT_RECEIPT,
  DOCUMENT_CATEGORIES.FINANCIAL,
];
const COMPANY_TENANT_DOC_GROUPS = [
  {
    groupKey: "company_identity",
    categoryKeys: [DOCUMENT_CATEGORIES.BUSINESS],
  },
  {
    groupKey: "legal_representative",
    categoryKeys: [DOCUMENT_CATEGORIES.IDENTIFICATION],
  },
  { groupKey: "company_income_taxes", categoryKeys: COMPANY_INCOME_CATEGORIES },
];
const DetailsDocs = (props) => {
  const {
    user = {},
    setVerifiedDocs,
    setClaveDocs,
    forensicRawData,
    forensicAnalysis,
    uploadDocModel,
    setUploadDocModel,
    isGuarantor = false,
    readOnly = false,
    isFromReport,
    currentLang,
    setGlobalTenantDocuments,
    setGlobalAllForensicDocuments,
    setGlobalMandatoryDocsList,
    setGlobalTenantDocsHistory,
    llShowOnly,
    isDeaRulesActivated,
    reportMode = false,
    missingDocumentsResolved = false,
    onDocsLoadingChange,
    onAnalysisComplete,
    // Optional card shown above Documents, in the same column (company
    // login tenants: the occupants card).
    topContent = null,
    // Called whenever the tenant's explanation note loads or changes so the
    // profile page can derive header counts from the same note.
    onMissingDocNoteChange = null,
  } = props;

  const forensicDocsMap = isDeaRulesActivated
    ? dea_missing_docs
    : forensic_docs_map;

  const { _t } = useTranslator();
  const {
    fetchTenantDocs,
    getZipDocs,
    deleteDocument,
    fetchServiceFiles,
    checkDocumentAnalysisStatus,
    saveMissingDocumentsNote,
  } = useContext(TenantContext);
  const { loadUserTenant, user: originalUser } = useContext(AuthContext);
  const [tenantDocsDataOriginal, setTenantDocsDataOriginal] = useState([]);
  const [tenantDocsLoaded, setTenantDocsLoaded] = useState(false);
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [tenantDocsHistory, setTenantDocsHistory] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mandatoryDocsList, setMandatoryDocsList] = useState({});
  const [docHistoryPopup, setDocHistoryPopup] = useState(false);
  const [selectedTypeForHistory, setSelectedTypeForHistory] = useState(null);
  const [docModel, setDocModel] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [allForensicDocuments, setAllForensicDocuments] = useState({});
  const [deleteDocumentConfirmation, setDeleteDocumentConfirmation] =
    useState(false);
  const [selectedDocument, setselectedDocument] = useState(null);
  const [deleteDocumentLoading, setDeleteDocumentLoading] = useState(false);
  const [documentsByType, setdocumentsByType] = useState({});
  const [employmentType, setEmploymentType] = useState("");
  const [forensicDocumentReport, setForensicDocumentReport] = useState({});
  const [showDropdown, setShowDropdown] = useState({
    first: false,
    sec: false,
    third: false,
    fourth: false,
    processing: false,
    protectedHousing: false,
  });
  const [allRenderedDocumentsCount, setAllRenderedDocumentsCount] = useState(0);
  const [selectedVerdicts, setSelectedVerdicts] = useState([]);
  const [analysisStatus, setAnalysisStatus] = useState("idle");
  const pollingTimeoutRef = useRef(null);
  const pollingActiveRef = useRef(false);
  const fetchFileDataRef = useRef(null);
  const onAnalysisCompleteRef = useRef(null);
  // All TenantServiceFiles for this profile (KYC / EXPERIAN / BANK_SCORE…).
  // Used to render "Used for …" tags on the linked documents.
  const [serviceFiles, setServiceFiles] = useState([]);
  const [serviceFilesLoaded, setServiceFilesLoaded] = useState(false);
  const [pendingDocumentNavigation, setPendingDocumentNavigation] =
    useState(null);
  const [highlightedDocumentIdentifiers, setHighlightedDocumentIdentifiers] =
    useState([]);
  const highlightTimeoutRef = useRef(null);
  // Tenant explanation note for the documents Skor did not detect
  // (TenantMissingDocNote). One note per tenant, shared with every landlord;
  // it never marks a document as received. Editable only on the tenant's
  // own profile view (landlord/admin views stay read-only in this phase).
  const [missingDocNote, setMissingDocNote] = useState(null);
  const [missingDocNoteModalOpen, setMissingDocNoteModalOpen] = useState(false);
  // The explanation note is editable only on the tenant's own profile view
  // (landlord/admin/report views stay read-only in this phase). Derived
  // directly from props so it is available to the effects below.
  const canManageMissingDocNote =
    !llShowOnly && !isFromReport && readOnly !== true && isGuarantor !== true;
  // Landlord report/profile views render the note read-only: per-row pills
  // scrolling to the note box at the end of Documentos.
  const showLandlordMissingDocNote =
    (llShowOnly || isFromReport) && isGuarantor !== true;

  useEffect(() => {
    const handleDocumentNavigation = (event) => {
      const request = event?.detail;
      if (
        String(request?.tenantId ?? "") !== String(user?._id ?? "") ||
        request?.isGuarantor !== (isGuarantor === true) ||
        !request?.identifiers?.length
      ) {
        return;
      }

      setPendingDocumentNavigation(request);
      console.info("[tenant-document-navigation] request accepted", {
        identifierCount: request.identifiers.length,
        isGuarantor: request.isGuarantor,
      });
    };

    window.addEventListener(
      TENANT_DOCUMENT_NAVIGATION_EVENT,
      handleDocumentNavigation
    );
    return () =>
      window.removeEventListener(
        TENANT_DOCUMENT_NAVIGATION_EVENT,
        handleDocumentNavigation
      );
  }, [user?._id, isGuarantor]);

  useEffect(
    () => () => {
      if (highlightTimeoutRef.current) {
        window.clearTimeout(highlightTimeoutRef.current);
      }
    },
    []
  );

  useEffect(() => {
    if (!haveValue(user?._id) || typeof fetchServiceFiles !== "function") {
      setServiceFiles([]);
      setServiceFilesLoaded(true);
      return;
    }
    let cancelled = false;
    setServiceFilesLoaded(false);
    fetchServiceFiles(user._id, undefined, false, isGuarantor)
      .then((res) => {
        if (cancelled) return;
        const files = res?.data?.success_res?.serviceFiles ?? [];
        setServiceFiles(Array.isArray(files) ? files : []);
        setServiceFilesLoaded(true);
      })
      .catch(() => {
        if (!cancelled) {
          setServiceFiles([]);
          setServiceFilesLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [user?._id, isGuarantor]);

  // Load the tenant's explanation note (GET /tenants/get/missing/docs/:id
  // returns it). Landlord views load the note read-only into local state
  // only — it is never lifted via onMissingDocNoteChange, so landlord header
  // counts and missing status stay unchanged.
  useEffect(() => {
    if (
      (!canManageMissingDocNote && !showLandlordMissingDocNote) ||
      !haveValue(user?._id)
    ) {
      return;
    }
    let cancelled = false;
    getEmploymentDocsMissing(user)
      .then((result) => {
        if (cancelled) return;
        const loadedNote = result?.missingDocNote ?? null;
        setMissingDocNote(loadedNote);
        if (!canManageMissingDocNote) return;
        if (typeof onMissingDocNoteChange === "function") {
          onMissingDocNoteChange(loadedNote);
        }
      })
      .catch(() => {
        if (cancelled) return;
        setMissingDocNote(null);
      });
    return () => {
      cancelled = true;
    };
  }, [
    canManageMissingDocNote,
    showLandlordMissingDocNote,
    user?._id,
    onMissingDocNoteChange,
  ]);

  // Canonical keys of the documents covered by the note, shared with the
  // forensic sections so explained rows show "View note" instead of the
  // missing warning. The documents themselves stay missing everywhere else.
  const explainedMissingDocKeys = useMemo(
    () => [...getExplainedDocCanonicalKeys(missingDocNote)],
    [missingDocNote]
  );

  const openMissingDocNoteModal = useCallback(() => {
    if (canManageMissingDocNote) setMissingDocNoteModalOpen(true);
  }, [canManageMissingDocNote]);

  // Landlord scrolling: per-row pills scroll down to the read-only note
  // box; the box's document entries scroll back up to their rows. Both
  // directions pair by canonical document key.
  // The lookup is scoped to the clicked subtree (.main_doc_div): the
  // document viewer modal renders a second copy of this whole tree, so a
  // global getElementById could grab the hidden copy and the visible one
  // would never move.
  const scrollScopeFor = (source) => {
    const element = source?.currentTarget ?? source;
    return element?.closest?.(".main_doc_div") ?? document;
  };
  const scrollToLandlordMissingDocNote = (source) => {
    const root = scrollScopeFor(source);
    const target =
      root.querySelector?.(`#${LANDLORD_MISSING_DOC_NOTE_BOX_ID}`) ??
      document.getElementById(LANDLORD_MISSING_DOC_NOTE_BOX_ID);
    target?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const scrollToMissingDocRow = (docKey, source) => {
    const anchorId = getMissingDocRowAnchorId(docKey);
    const findRow = () => {
      const root = scrollScopeFor(source);
      return (
        root.querySelector?.(`#${CSS.escape(anchorId)}`) ??
        document.getElementById(anchorId)
      );
    };
    const scrollNow = () => {
      findRow()?.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    if (findRow()) {
      scrollNow();
      return;
    }
    // The row lives in a collapsed document section: expand the sections
    // that can hold explained rows, then scroll once they render (retried
    // briefly in case rendering lags behind the state update).
    setShowDropdown((prev) => ({
      ...prev,
      sec: true,
      third: true,
      protectedHousing: true,
    }));
    let attempts = 0;
    const tryScrollAfterExpand = () => {
      attempts += 1;
      if (findRow()) {
        scrollNow();
      } else if (attempts < 10) {
        setTimeout(tryScrollAfterExpand, 100);
      }
    };
    setTimeout(tryScrollAfterExpand, 50);
  };

  // Save the tenant's explanation note from the profile modal (same note as
  // the sign-up step: saving replaces it). Unselecting everything and saving
  // deletes it, so reminders resume for those documents.
  const handleSaveMissingDocNote = async ({
    explainedDocuments,
    explanationMessage,
  }) => {
    const savedNote = await saveMissingDocumentsNote(user?._id, {
      explainedDocuments,
      explanationMessage,
      origin: "profile",
    }).catch(() => {
      toast.error(_t("errorSubmitting"));
      return undefined;
    });
    // saveMissingDocumentsNote throws on failure (toast shown above): keep
    // the modal open so the tenant does not lose their selection.
    if (savedNote === undefined) return;
    const nextNote = savedNote ?? null;
    setMissingDocNote(nextNote);
    setMissingDocNoteModalOpen(false);
    if (typeof onMissingDocNoteChange === "function") {
      onMissingDocNoteChange(nextNote);
    }
  };

  // tenant_doc_id / file_name → [SERVICE…]. Keep KYC tags scoped to the latest
  // KYC run so previous identity documents aren't marked as currently used.
  const serviceTagsByDocKey = useMemo(() => {
    const map = new Map();
    const latestKycFiles = new Set(getLatestKycServiceFiles(serviceFiles));
    const add = (key, service) => {
      if (!haveValue(key) || !haveValue(service)) return;
      const k = String(key);
      if (!map.has(k)) map.set(k, []);
      const upper = String(service).toUpperCase().trim();
      if (upper && !map.get(k).includes(upper)) map.get(k).push(upper);
    };
    serviceFiles.forEach((file) => {
      if (
        String(file?.service ?? "")
          .toUpperCase()
          .trim() === "KYC" &&
        !latestKycFiles.has(file)
      ) {
        return;
      }
      add(file?.tenant_doc_id, file?.service);
      add(file?.tenant_doc_id?.$oid, file?.service);
      add(file?.file_name, file?.service);
      if (haveValue(file?.file_name))
        add(String(file.file_name).split("/").pop(), file?.service);
      add(file?.metadata?.originalname, file?.service);
    });
    return map;
  }, [serviceFiles]);

  const getDocServiceTags = (doc) => {
    if (!doc) return [];
    const keys = [doc?._id, doc?.document_id, doc?.file_name];
    if (haveValue(doc?.file_name))
      keys.push(String(doc.file_name).split("/").pop());
    const tags = [];
    keys.forEach((key) => {
      if (!haveValue(key)) return;
      (serviceTagsByDocKey.get(String(key)) ?? []).forEach((service) => {
        // A bank statement belonging to another user must not advertise
        // the bank score — drop only the BANK_SCORE tag in that case.
        if (service === "BANK_SCORE" && isOtherUserDoc(doc)) return;
        if (!tags.includes(service)) tags.push(service);
      });
    });
    return tags;
  };

  const isProfileOutdated = !!(user?.profile_outdated || user?.is_outdated);
  // Tenant viewing a guarantor's profile is strictly view-only: no uploads,
  // no deletes. `isGuarantor` covers existing callers; `readOnly` is explicit.
  const isReadOnly = readOnly === true || isGuarantor === true;

  const toggleVerdictFilter = (verdict) => {
    setSelectedVerdicts((prev) =>
      prev.includes(verdict)
        ? prev.filter((v) => v !== verdict)
        : [...prev, verdict]
    );
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (reportMode) {
      if (haveValue(user?.tenantDocs)) {
        setTenantDocsDataOriginal(withoutOccupantDocs(user.tenantDocs));
      } else {
        removeDocsData();
      }
      setTenantDocsLoaded(true);
      selectMandatoryDocsList();
      return;
    }
    fetchFileData();
    selectMandatoryDocsList();
  }, [user, reportMode]);

  const getKeyFactorByType = (keyFactorsArray, targetKey) => {
    return keyFactorsArray.find(
      (kf) => kf?.keyFactor?.toLowerCase() === targetKey.toLowerCase()
    );
  };

  const getDocumentAnalysisPayload = () =>
    user?.tenant_extra_id?.document_analysis ??
    user?.tenant_extra_field_id?.document_analysis ??
    {};

  const getFileNameFromUrl = (url) => {
    if (!haveValue(url) || typeof url !== "string") return "";

    try {
      const pathname = new URL(url).pathname;
      return pathname?.split("/").filter(Boolean).pop() ?? "";
    } catch (error) {
      return url?.split("?")[0]?.split("/").filter(Boolean).pop() ?? "";
    }
  };

  const getMappedDbType = (analysisDoc = {}, bucket = {}) => {
    const analysisTypeMap = {
      "National Identity Card (Front)": "national_identity_card_front",
      "National Identity Card (Back)": "national_identity_card_back",
      "Residence Permit (Front)": "residence_permit_front",
      "Residence Permit (Back)": "residence_permit_back",
      Passport: "passport",
    };

    return (
      analysisTypeMap?.[analysisDoc?.documentName] ??
      analysisTypeMap?.[bucket?.bucketName] ??
      docsMap?.[analysisDoc?.documentName] ??
      docsMap?.[bucket?.bucketName] ??
      analysisDoc?.documentName ??
      bucket?.bucketName ??
      ""
    );
  };

  const primaryProfileName =
    forensicAnalysis?.Name?.dataInJSON?.name ??
    `${user?.fname ?? ""} ${user?.lname ?? ""}`.trim();

  // Ownership check bound to this profile; shared implementation in
  // Utils/tenantDocOwnership (row badges, owner labels, third-party styling).
  // Company login tenants: the company and its signatories' IDs are its own.
  const isOtherUserDoc = (doc) => {
    if (
      doc &&
      isCompanyTenantOwnDocument(user, {
        isUploader: doc?.analysisIsUploader,
        doc,
      })
    )
      return false;
    return isDocOwnedByOtherPerson(doc, primaryProfileName);
  };

  const getDisplayDocName = (doc) => {
    if (!doc) return "";
    const langKey = currentLang === "en-us" ? "en" : "es";

    const bucketNameTranslated =
      doc?.documentAnalysisData?.localDocumentName?.[langKey] ||
      doc?.documentAnalysisData?.documentNameTranslated?.[langKey] ||
      doc?.documentAnalysisData?.documentName;

    if (haveValue(bucketNameTranslated)) return bucketNameTranslated;

    if (haveValue(doc?.bucketName)) return doc.bucketName;

    return (
      allForensicDocuments?.[doc?.file_name]?.localDocumentName?.[
        currentLang === "en-us" ? "en" : "es"
      ] ||
      allForensicDocuments?.[doc?.file_name]?.documentNameTranslated?.[
        currentLang === "en-us" ? "en" : "es"
      ] ||
      allForensicDocuments?.[doc?.file_name]?.documentName ||
      doc?.documentAnalysisData?.localDocumentName?.[
        currentLang === "en-us" ? "en" : "es"
      ] ||
      doc?.documentAnalysisData?.documentNameTranslated?.[
        currentLang === "en-us" ? "en" : "es"
      ] ||
      doc?.documentAnalysisData?.documentName ||
      _t(doc?.type, "", "fixed")
    );
  };

  const getDocsForType = (targetType, categoryKeys = []) => {
    const keys = Array.isArray(categoryKeys) ? categoryKeys : [];

    return (tenantDocsData ?? [])
      .filter((doc) => {
        if (doc?.type === "uploaded-from-onboarding") return false;

        const matchesType = doc?.type === targetType;
        const matchesCategory =
          !!doc?.categoryKey && keys.includes(doc?.categoryKey);

        // Keep old behavior and include category-key matches as an additional rule.
        return matchesType || matchesCategory;
      })
      .filter((doc, index, docs) => {
        const uniqueKey =
          doc?.id ??
          doc?._id ??
          doc?.document_id ??
          doc?.file_name ??
          `${doc?.type}-${doc?.categoryKey}-${doc?.created_at}-${index}`;

        return (
          docs.findIndex((d, i) => {
            const dKey =
              d?.id ??
              d?._id ??
              d?.document_id ??
              d?.file_name ??
              `${d?.type}-${d?.categoryKey}-${d?.created_at}-${i}`;

            return dKey === uniqueKey;
          }) === index
        );
      })
      .sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at));
  };

  const getPayslipDocs = () =>
    (tenantDocsData ?? [])
      .filter((doc) => doc?.type?.toLowerCase()?.includes("payslip"))
      .sort((a, b) => new Date(b?.created_at) - new Date(a?.created_at));

  const matchesSelectedVerdicts = (doc) => {
    if (!doc) return false;
    if (selectedVerdicts.length === 0) return true;

    let verdict =
      doc?.type === "Declaration Consent"
        ? "NORMAL"
        : forensicDocumentReport?.[doc?.file_name]?.verdict;

    const isScanned =
      doc?.type === "Declaration Consent"
        ? false
        : forensicDocumentReport?.[doc?.file_name]?.documentType ===
            "is_scanned_document" ||
          forensicDocumentReport?.[doc?.file_name]?.isScannedDocument === "yes";

    if (isScanned) {
      verdict = "SCANNED";
    }

    return (
      (!verdict && selectedVerdicts.includes("WARNING")) ||
      selectedVerdicts.includes(verdict)
    );
  };

  const getDocKey = (doc) => {
    if (!doc) return null;
    return (
      doc?.file_name ??
      doc?._id ??
      doc?.id ??
      doc?.document_id ??
      `${doc?.type ?? ""}-${doc?.categoryKey ?? ""}-${doc?.created_at ?? ""}`
    );
  };

  const getUsedDocsInSections = () => {
    const usedKeys = new Set();
    const addDocs = (docs) => {
      (Array.isArray(docs) ? docs : []).forEach((doc) => {
        const key = getDocKey(doc);
        if (key) usedKeys.add(key);
      });
    };

    const idDocs = forensicDocsMap?.[employmentType]?.identification ?? [];
    idDocs.forEach((item) => {
      addDocs(getDocsForType(item, [DOCUMENT_CATEGORIES.IDENTIFICATION]));
    });

    const empStatus =
      forensicDocsMap?.[employmentType]?.employment_status ?? {};
    const empDocs = [
      ...(empStatus?.compulsory ?? []),
      ...(empStatus?.additional ?? []),
    ];
    empDocs.forEach((item) => {
      addDocs(getDocsForType(item, [DOCUMENT_CATEGORIES.EMPLOYMENT_STATUS]));
    });

    const incomeStatus = forensicDocsMap?.[employmentType]?.income_taxes ?? {};
    const incomeDocs = [
      ...(incomeStatus?.compulsory ?? []),
      ...(incomeStatus?.additional ?? []),
    ];
    incomeDocs.forEach((item) => {
      if (item?.toLowerCase()?.includes("payslip")) {
        addDocs(getPayslipDocs());
      } else {
        addDocs(
          getDocsForType(item, [
            DOCUMENT_CATEGORIES.TAX,
            DOCUMENT_CATEGORIES.INCOME,
            DOCUMENT_CATEGORIES.PAYMENT_RECEIPT,
            DOCUMENT_CATEGORIES.FINANCIAL,
          ])
        );
      }
    });

    // Company login tenants: their groups (see COMPANY_TENANT_DOC_GROUPS).
    COMPANY_TENANT_DOC_GROUPS.forEach(({ groupKey, categoryKeys }) => {
      const group = forensicDocsMap?.[employmentType]?.[groupKey] ?? {};
      [...(group?.compulsory ?? []), ...(group?.additional ?? [])].forEach(
        (item) => addDocs(getDocsForType(item, categoryKeys))
      );
    });

    const housingDocs = getRequiredProtectedHousingDocs();
    housingDocs.forEach((item) => {
      addDocs(getDocsForType(item));
    });

    return usedKeys;
  };

  const currentLandlordWorkspace =
    originalUser?.workspaceIds?.find(
      (workspace) =>
        String(workspace?._id) ===
        String(
          originalUser?.current_workspace?._id ??
            originalUser?.current_workspace
        )
    ) ?? originalUser?.current_workspace;
  const showClientIdentificationMissingDoc =
    llShowOnly &&
    tenantDocsLoaded &&
    isClientIdentificationPending(
      user,
      isClientIdentificationActive(originalUser) ||
        isClientIdentificationActive(currentLandlordWorkspace)
    ) &&
    !(tenantDocsDataOriginal ?? []).some(
      (doc) => doc?.type === "Client Identification Form"
    );

  const getOtherDocs = () => {
    const usedDocKeys = getUsedDocsInSections();

    let otherDocs = (tenantDocsData ?? []).filter(
      (doc) =>
        doc?.type !== "uploaded-from-onboarding" &&
        !usedDocKeys.has(getDocKey(doc)) &&
        !doc?.file_name?.includes("grupomutuoconsent_") &&
        !doc?.file_name?.includes("skorconsent_")
    );

    if (selectedVerdicts.length > 0) {
      otherDocs = otherDocs.filter((doc) => matchesSelectedVerdicts(doc));
    }

    return otherDocs;
  };

  useEffect(() => {
    const tempMap = new Map(); // Tracks 'clave' types
    const typeMap = new Map(); // Latest doc per type (strictly by type)
    const otherDocs = []; // Docs with 'others' source
    const publicHousingMap = new Map(); // Latest doc per type for public housing
    const docHistoryMap = new Map(); // All docs grouped by type for history
    const verifiedDocsMap = new Map();
    if (
      Array.isArray(tenantDocsDataOriginal) &&
      tenantDocsDataOriginal.length > 0
    ) {
      const docsByFileName = new Map();
      const docsByType = new Map();

      tenantDocsDataOriginal.forEach((doc) => {
        if (haveValue(doc?.file_name)) {
          docsByFileName.set(doc.file_name, doc);
          docsByFileName.set(doc.file_name.split("/").pop(), doc);
        }

        if (!docsByType.has(doc?.type)) {
          docsByType.set(doc?.type, []);
        }
        docsByType.get(doc?.type).push(doc);

        // Track 'clave' types
        if (doc?.from === "clave") {
          tempMap.set(doc.file_name, doc);
        }
        // Keep latest doc per unique type for main display, excluding 'others'
        if (doc?.from !== constants.others) {
          const existingDoc = typeMap.get(doc.type);

          if (
            !existingDoc ||
            new Date(doc.created_at) > new Date(existingDoc.created_at)
          ) {
            typeMap.set(doc.type, doc);
          }
        }
        // Collect 'others' docs
        if (doc?.from === "others") {
          if (!doc?.type?.toLowerCase().includes("payslip")) {
            otherDocs.push(doc);
          }
        }
        // Keep latest doc per type for public housing docs
        if (doc?.from === "public_housing_docs") {
          const existing = publicHousingMap.get(doc.type);
          if (
            !existing ||
            new Date(doc.created_at) > new Date(existing.created_at)
          ) {
            publicHousingMap.set(doc.type, doc);
          }
        }
        // Build document history map by type
        if (!docHistoryMap.has(doc.type)) {
          docHistoryMap.set(doc.type, []);
        }
        docHistoryMap.get(doc.type).push(doc);
        //Get map of all Verified Docs
        if (!verifiedDocsMap.has(doc.type) && doc?.verified) {
          verifiedDocsMap.set(doc.file_name, doc);
        }
      });

      docsByType.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });

      // Sort history arrays descending (latest first)
      docHistoryMap.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });
      // Prepare final list for main display
      const publicHousingDocsSorted = Array.from(
        publicHousingMap.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      const publicHousingTypes = new Set(
        publicHousingDocsSorted.map((doc) => doc.type)
      );
      const filteredTypeMapDocs = Array.from(typeMap.values()).filter(
        (doc) =>
          !publicHousingTypes.has(doc.type) &&
          !doc?.type?.toLowerCase().includes("payslip")
      );
      const allPayslips = tenantDocsDataOriginal.filter((d) =>
        d?.type?.toLowerCase().includes("payslip")
      );
      const finalDocs = [
        ...filteredTypeMapDocs,
        ...publicHousingDocsSorted,
        ...allPayslips,
        ...otherDocs,
      ];
      // add uploaded for field in each doc
      const docListWithKeyFactor = {};
      (Array.isArray(forensicRawData) ? forensicRawData : []).forEach(
        (entry) => {
          const name = getKeyFactorByType(
            entry?.report?.keyFactors?.keyFactors,
            "Name"
          )?.dataInJSON?.name;
          if (name) {
            docListWithKeyFactor[name] = entry?.report?.documents_list || [];
          }
        }
      );

      finalDocs.forEach((doc) => {
        for (const [name, docs] of Object.entries(docListWithKeyFactor)) {
          const matched = docs.find((d) => {
            const extracted = d?.url?.split(
              `/${process.env.REACT_APP_CDN_CONTAINER}/`
            )[1];
            return extracted === doc.file_name;
          });
          if (matched) {
            doc.uploadedFor = name;
            break;
          }
        }
      });

      const allForensicDocuments = (
        Array.isArray(forensicRawData) ? forensicRawData : []
      ).flatMap((entry) => {
        return (entry?.report?.documents_list || []).map((doc) => ({
          ...doc,
        }));
      });

      let forensicDocsObj = {};
      allForensicDocuments.forEach((doc) => {
        const extractedFileName = doc?.url?.split(
          `/${process.env.REACT_APP_CDN_CONTAINER}/`
        )[1];

        const extractedFileNameClean = extractedFileName?.split(`?`)?.[0];

        if (extractedFileNameClean) {
          forensicDocsObj[extractedFileNameClean] = doc;
        }
      });

      setAllForensicDocuments(forensicDocsObj);
      setGlobalAllForensicDocuments?.(forensicDocsObj);

      const documentAnalysis =
        getDocumentAnalysisPayload()?.profileReports ?? [];
      const uploaderProfile = documentAnalysis.find(
        (profile) => profile?.data?.is_uploader
      );
      const orderedProfiles = uploaderProfile
        ? [
            uploaderProfile,
            ...documentAnalysis.filter(
              (profile) => profile !== uploaderProfile
            ),
          ]
        : documentAnalysis;

      const analysisMatchedFileNames = new Set();
      const analysisBucketRows = [];

      orderedProfiles.forEach((profile) => {
        const ownerName = profile?.data?.owner || profile?.owner;
        const ownerType = profile?.data?.owner_type || profile?.owner_type;
        const documentBuckets = profile?.report?.documentBuckets ?? [];

        documentBuckets.forEach((bucket) => {
          const bucketDocuments = Array.isArray(bucket?.documents)
            ? bucket.documents
            : [];

          if (!bucketDocuments.length) return;

          const bucketDbMatches = bucketDocuments
            .map((analysisDoc) => {
              const bucketUrl =
                analysisDoc?.url ??
                analysisDoc?.data?.url ??
                analysisDoc?.data?.filename;
              const extractedFileName = getFileNameFromUrl(bucketUrl);
              const mappedType = getMappedDbType(analysisDoc, bucket);

              const matchedDoc =
                docsByFileName.get(extractedFileName) ??
                docsByType
                  .get(mappedType)
                  ?.find(
                    (doc) => !analysisMatchedFileNames.has(doc?.file_name)
                  ) ??
                docsByType.get(mappedType)?.[0];

              if (matchedDoc?.file_name) {
                analysisMatchedFileNames.add(matchedDoc.file_name);
              }

              return {
                analysisDoc,
                matchedDoc,
                mappedType,
              };
            })
            .filter(
              (entry) =>
                haveValue(entry?.mappedType) &&
                (haveValue(entry?.matchedDoc) || haveValue(entry?.analysisDoc))
            );

          bucketDbMatches.forEach((entry) => {
            if (entry?.matchedDoc?.file_name) {
              analysisMatchedFileNames.add(entry.matchedDoc.file_name);
            }
          });

          const selectedBucketDoc =
            bucketDbMatches.find(
              (entry) =>
                entry?.analysisDoc?.isDuplicate !== true &&
                haveValue(entry?.matchedDoc)
            ) ??
            bucketDbMatches.find(
              (entry) => entry?.analysisDoc?.isDuplicate !== true
            ) ??
            bucketDbMatches[0];

          if (!selectedBucketDoc) return;

          let { analysisDoc, matchedDoc, mappedType } = selectedBucketDoc;
          const fallbackFileName = getFileNameFromUrl(
            analysisDoc?.url ?? analysisDoc?.data?.url
          );

          if (
            user?.employment_status === constants.company &&
            mappedType === constants.quarterly_vat
          ) {
            const periodQuarter =
              analysisDoc?.documentAnalysisData?.period_quarter ??
              analysisDoc?.data?.period_quarter ??
              analysisDoc?.period_quarter;

            if (periodQuarter) {
              mappedType = `${mappedType} Q${periodQuarter}`;
            }
          }

          if (
            user?.employment_status === constants.company &&
            mappedType === constants.quarterly_vat
          ) {
            const periodQuarter =
              analysisDoc?.documentAnalysisData?.period_quarter ??
              analysisDoc?.data?.period_quarter ??
              analysisDoc?.period_quarter;

            if (periodQuarter) {
              mappedType = `${mappedType} Q${periodQuarter}`;
            }
          }

          if (matchedDoc) {
            analysisBucketRows.push({
              ...(matchedDoc ?? {}),
              type: mappedType,
              file_name: matchedDoc?.file_name ?? fallbackFileName,
              created_at: matchedDoc?.created_at ?? matchedDoc?.updated_at,
              uploadedFor:
                matchedDoc?.uploadedFor ??
                (profile?.data?.is_uploader ? "" : ownerName),
              analysisOwnerName: ownerName,
              analysisOwnerType: ownerType,
              analysisIsUploader: profile?.data?.is_uploader === true,
              bucketName: bucket?.bucketName ?? analysisDoc?.bucketName,
              categoryKey: analysisDoc?.categoryKey,
              bucketKey: bucket?.bucketKey,
              bucketDocuments: bucketDbMatches
                .map((entry) => entry?.matchedDoc)
                .filter(Boolean),
              documentAnalysisData: analysisDoc,
              isDocumentAnalysisBucket: true,
            });
          } else {
            console.log(
              "ERROR: Document is missing in the db docs, but it is present in the analysis bucket"
            );
          }
        });
      });

      // Freelancers: RETA receipts of the last 3 months take their slot
      // type ("1st month RETA receipt", ...), see retaRequirement.js.
      const finalDocsToUse = applyRetaSlotTypes(
        analysisBucketRows.length > 0
          ? [
              ...analysisBucketRows,
              ...finalDocs.filter(
                (doc) =>
                  !analysisMatchedFileNames.has(doc?.file_name) &&
                  doc?.type !== "uploaded-from-onboarding"
              ),
            ]
          : finalDocs,
        {
          user,
          forensicList: allForensicDocuments,
          forensicByFile: forensicDocsObj,
        }
      );
      finalDocsToUse.forEach((doc) => {
        if (RETA_ORDER.includes(doc?.type) && !docHistoryMap.has(doc.type)) {
          docHistoryMap.set(doc.type, [doc]);
        }
      });

      finalDocsToUse.sort((a, b) => {
        const getPriority = (doc) => {
          if (doc?.from === "clave") return 0;
          if (doc?.verified === true) return 1;
          return 2;
        };

        return getPriority(a) - getPriority(b);
      });

      // Documents sorted by created and map by type
      const sortedAndMappedByType = finalDocsToUse
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .reduce((acc, doc) => {
          if (!acc[doc.type]) acc[doc.type] = doc; // only take the latest
          return acc;
        }, {});

      setdocumentsByType(sortedAndMappedByType);
      setTenantDocsData(finalDocsToUse);
      setGlobalTenantDocuments?.(finalDocsToUse);
      setTenantDocsHistory(Object.fromEntries(docHistoryMap));
      setGlobalTenantDocsHistory?.(Object.fromEntries(docHistoryMap));
      setVerifiedDocs(verifiedDocsMap);
      setClaveDocs(tempMap);
    }
  }, [tenantDocsDataOriginal, forensicRawData]);

  useEffect(() => {
    const forensicReportsMap = (
      Array.isArray(forensicRawData) ? forensicRawData : []
    )
      .flatMap((entry) => entry?.report?.forensic_reports || [])
      .reduce((acc, report) => {
        const fileName = report?.fileUrl?.split("/")?.pop();
        if (fileName) acc[fileName] = report;
        return acc;
      }, {});

    setForensicDocumentReport(forensicReportsMap);
  }, [forensicRawData]);

  const removeDocsData = () => {
    setTenantDocsData([]);
    setGlobalTenantDocuments?.([]);
    setTenantDocsHistory({});
    setGlobalTenantDocsHistory?.({});
    setTenantDocsDataOriginal([]);
  };

  const fetchFileData = async () => {
    if (haveValue(user)) {
      let userid = user?._id;
      onDocsLoadingChange?.(true);
      setTenantDocsLoaded(false);
      try {
        const res = await fetchTenantDocs(userid, false, isGuarantor);
        if (haveValue(res?.data?.success_res?.tenantDocs)) {
          setTenantDocsDataOriginal(
            withoutOccupantDocs(res?.data?.success_res?.tenantDocs)
          );
        } else {
          removeDocsData();
        }
      } finally {
        setTenantDocsLoaded(true);
        onDocsLoadingChange?.(false);
      }
    }
  };

  const getRequiredProtectedHousingDocs = () => {
    if (
      llShowOnly &&
      originalUser?.current_workspace?.protected_housing_enabled === false
    ) {
      return [];
    }

    const selectedProtectedDocs =
      user?.tenant_extra_field_id?.[constants.public_housing_fileFrom] ?? [];

    const residencyDoc = constants.certificate_of_residency_registration;
    const hasNoSpecialCircumstances = selectedProtectedDocs.includes(
      constants.no_special_circumstances
    );
    const baseProtectedDocs = selectedProtectedDocs.filter(
      (doc) =>
        doc &&
        doc !== residencyDoc &&
        doc !== constants.no_special_circumstances &&
        doc !== "no"
    );

    if (baseProtectedDocs.length > 0) {
      return Array.from(new Set([...baseProtectedDocs, residencyDoc]));
    }

    if (hasNoSpecialCircumstances) {
      return [residencyDoc];
    }

    return [];
  };

  const selectMandatoryDocsList = () => {
    let employment_docs = {};
    let selectedEmploymentType = "employed";
    if (user?.employment_status == "student") {
      selectedEmploymentType = "student";
      employment_docs = constants.PROFESSION_DOCS.STUDENT_DOCS;
    } else if (user?.employment_status == "employed") {
      selectedEmploymentType =
        user?.employment_category === constants.domestic_worker
          ? constants.domestic_worker
          : constants.employed;
      employment_docs =
        user?.employment_category === constants.domestic_worker
          ? constants.PROFESSION_DOCS.DOMESTIC_WORKER_DOCS
          : constants.PROFESSION_DOCS.EMPLOYED_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      user?.employment_category === "freelancer"
    ) {
      selectedEmploymentType = "freelancer";
      employment_docs = constants.PROFESSION_DOCS.FREELANCER_DOCS;
    } else if (
      user?.employment_status == "self_employed" &&
      user?.employment_category === "ownACompany"
    ) {
      selectedEmploymentType = "ownACompany";
      employment_docs = constants.PROFESSION_DOCS.SELF_EMPLOYED_DOCS;
    } else if (user?.employment_status == "retired") {
      selectedEmploymentType = "retired";
      employment_docs = constants.PROFESSION_DOCS.RETIRED_DOCS;
    } else if (user?.employment_status == "unemployed") {
      selectedEmploymentType = "unemployed";
      employment_docs = constants.PROFESSION_DOCS.UNEMPLOYED_DOCS;
    } else if (user?.employment_status == "public_servant") {
      selectedEmploymentType = "public_servant";
      employment_docs = constants.PROFESSION_DOCS.PUBLIC_SERVANT_DOCS;
    } else if (user?.employment_status == "company") {
      selectedEmploymentType = "company";
      employment_docs = constants.PROFESSION_DOCS.COMPANY_DOCS;
    } else if (user?.employment_status == constants.company_tenant) {
      // Company login tenants: their own list (type -> type, like the
      // PROFESSION_DOCS lists).
      selectedEmploymentType = constants.company_tenant;
      employment_docs = Object.fromEntries(
        Object.keys(docsData.COMPANY_TENANT_DOCS).map((type) => [type, type])
      );
    }
    const requiredProtectedHousingDocs = getRequiredProtectedHousingDocs();
    if (requiredProtectedHousingDocs.length > 0) {
      requiredProtectedHousingDocs.forEach((docType) => {
        employment_docs[docType] = docType;
      });
    }
    setEmploymentType(selectedEmploymentType);
    setMandatoryDocsList(employment_docs);
    setGlobalMandatoryDocsList?.(employment_docs);
  };

  const [showSpinner, setShowSpinner] = useState();

  const handleZipDown = () => {
    setShowSpinner(true);
    getZipDocs(user?._id, isGuarantor)
      .then((res) => {
        const nodeJSBuffer = res.data.images.data;
        const uint8Array = new Uint8Array(nodeJSBuffer);

        // Convert Uint8Array to ArrayBuffer
        const arrayBuffer = uint8Array.buffer;

        // Create a Blob
        const blob = new Blob([arrayBuffer], {
          type: "application/octet-stream",
        });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${user?.fname + " " + (user?.lname ?? "")}.zip`;

        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
        setShowSpinner(false);
      })
      .catch((err) => {
        setShowSpinner(false);
        console.log(err);
      });
  };

  const handlePreviewDocument = (url) => {
    window.open(url, "blank");
  };

  const hasModel100Fallback = (key) =>
    key.toLowerCase().includes("model 100") &&
    // A company's tax docs (e.g. Model 200, Model 036) are not the tenant's
    // own income tax return, so they must not satisfy Model 100.
    tenantDocsData.some(
      (doc) =>
        doc?.categoryKey === DOCUMENT_CATEGORIES.TAX &&
        doc?.analysisOwnerType !== "legal_entity" &&
        doc?.documentAnalysisData?.ownerType !== "legal_entity"
    );

  const getPayslipUploadedCount = (history) =>
    Object.entries(history || {})
      .filter(([historyKey]) => historyKey.toLowerCase().includes("payslip"))
      .reduce(
        (sum, [, docs]) => sum + (Array.isArray(docs) ? docs.length : 0),
        0
      );

  // Slot-aware payslip requirement for employed / public_servant: the 3
  // payslips must cover the last-3-months periods (same as Income & Taxes
  // slots). Stale docs outside the window do NOT satisfy a slot.
  const isThreePayslipRequiredHere =
    employmentType === "employed" ||
    employmentType === "public_servant" ||
    isThreePayslipEmploymentStatus(user?.employment_status);
  const payslipSlotInfo = useMemo(
    () =>
      countFilledPayslipSlots(tenantDocsData, {
        user,
        forensicRawData,
        forensicByFile: allForensicDocuments,
      }),
    [tenantDocsData, user, forensicRawData, allForensicDocuments]
  );

  const missingDocs = (() => {
    const entries = Object.entries(mandatoryDocsList);
    const hasPayslipRequirement = entries.some(([key]) =>
      key.toLowerCase().includes("payslip")
    );
    const useSlots = hasPayslipRequirement && isThreePayslipRequiredHere;
    // Expand generic "Payslip" into the 3 ordered slots so each missing
    // period is reported (consistent with skorList + display slots).
    const expandedEntries = [];
    entries.forEach(([key, val]) => {
      const lower = key.toLowerCase();
      if (useSlots && (lower === "payslip" || lower === "last 3 payslips")) {
        PAYSLIP_ORDER.forEach((k) => expandedEntries.push([k, k]));
      } else {
        expandedEntries.push([key, val]);
      }
    });
    // Slot-filled count when slots apply, else document count (all payslips
    // share the single DB type "Payslip", so count docs, not history keys).
    const payslipSatisfiedCount = useSlots
      ? payslipSlotInfo.filled
      : getPayslipUploadedCount(tenantDocsHistory);
    return expandedEntries.filter(([key]) => {
      const isPayslipKey = key.toLowerCase().includes("payslip");

      if (hasModel100Fallback(key)) return false;

      if (isPayslipKey) {
        const index = PAYSLIP_ORDER.indexOf(key);

        if (index !== -1) {
          if (index < payslipSatisfiedCount) {
            return false;
          }
        } else {
          // Generic mandatory key for non-slot types: satisfied when enough
          // payslip documents exist (1, or 3 for "last 3").
          const needed = key.toLowerCase() === "last 3 payslips" ? 3 : 1;
          if (payslipSatisfiedCount >= needed) {
            return false;
          }
        }
      }

      return !(key in tenantDocsHistory && !isPayslipKey);
    });
  })();

  // const missingDocs = Object.entries(mandatoryDocsList).filter(
  //   ([key]) => !(key in tenantDocsHistory)
  // );

  // Keys of the requested documents that are still missing (same vocabulary
  // as the rows below). Explained documents stay in this list — the note
  // never marks them as received — but they are excluded from the section
  // header and from "still to upload" counts via filterUnexplainedMissingDocs.
  const missingDocKeys = useMemo(
    () => (missingDocs || []).map(([key]) => key),
    [missingDocs]
  );

  // Identification documents are Onfido-verified, never explainable. The
  // exclusion names come from the category config and the required-docs map
  // (all employment types), not from hardcoded strings.
  const identityDocNames = useMemo(() => {
    const names = [
      ...(DOCUMENT_CATEGORY_CONFIG?.[DOCUMENT_CATEGORIES.IDENTIFICATION] ?? []),
    ];
    Object.values(forensicDocsMap ?? {}).forEach((entry) => {
      (entry?.identification ?? []).forEach((item) => {
        if (item) names.push(item);
      });
    });
    return names;
  }, [forensicDocsMap]);

  // Checkbox options for the explanation modal: simply the missing documents
  // for this employment type, de-duplicated by canonical key and excluding
  // identity documents (Onfido-verified, never explainable). No third-party
  // or backend extras — uploaded docs belonging to another person are never
  // listed here.
  const modalMissingDocOptions = useMemo(() => {
    const byCanonicalKey = new Map();
    missingDocKeys.forEach((key) => {
      const canonical =
        canonicalizeMissingDocKey(key) || String(key).toLowerCase();
      if (!byCanonicalKey.has(canonical))
        byCanonicalKey.set(canonical, { key, label: key });
    });
    // Identity documents are verified through Onfido, not uploads — never
    // explainable, never listed here, whatever the source vocabulary.
    return [...byCanonicalKey.values()].filter(
      (option) => !isIdentityDocumentKey(option.key, identityDocNames)
    );
  }, [missingDocKeys, identityDocNames]);

  const modalMissingDocLabelByKey = useMemo(() => {
    const labelByKey = new Map();
    modalMissingDocOptions.forEach((option) => {
      labelByKey.set(option.key, option.label);
    });
    return labelByKey;
  }, [modalMissingDocOptions]);

  // The tenant's note trimmed to entries that are still missing (same rule
  // as the header count in skorList, via the shared helper). Null when
  // nothing is missing anymore so the landlord box hides entirely; the
  // footer count below uses the same trimmed entries.
  const visibleMissingDocNote = useMemo(() => {
    if (!missingDocNote) return null;
    const visibleEntries = filterStillMissingNoteEntries(
      missingDocNote.explainedDocuments,
      modalMissingDocOptions.map((option) => option.key)
    );
    if (visibleEntries.length === 0) return null;
    return { ...missingDocNote, explainedDocuments: visibleEntries };
  }, [missingDocNote, modalMissingDocOptions]);

  const merged = [
    ...tenantDocsData,
    ...(missingDocs || []).map((doc) => ({
      ...doc,
      type: "missing",
    })),
  ];

  const reportMidpoint = Array.isArray(merged)
    ? Math.ceil(merged.length / 2)
    : 0;
  const reportDocsFirstHalf = Array.isArray(merged)
    ? merged.slice(0, reportMidpoint)
    : [];
  const reportDocsSecondHalf = Array.isArray(merged)
    ? merged.slice(reportMidpoint)
    : [];

  const docsToRender = isFromReport ? reportDocsFirstHalf : tenantDocsData;

  const handleDeleteDocument = async (doc_id) => {
    try {
      setDeleteDocumentLoading(true);
      await deleteDocument(doc_id, user?._id);
      if (originalUser?.role == "tenant") {
        await loadUserTenant("tenant");
      }
      await fetchFileData("tenant");
      setDeleteDocumentConfirmation(false);
    } catch (err) {
      toast.error(_t("failedToDeleteDocument"));
    } finally {
      setDeleteDocumentLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);
  const desktopDocumentsRootRef = useRef(null);
  const mobileDocumentsRootRef = useRef(null);
  const getSectionForDocumentRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const isTogglingDropdown = useRef(false);

  const handleViewDocument = (e, doc) => {
    e.preventDefault();
    e.stopPropagation();
    if (scrollContainerRef.current) {
      setScrollPosition(scrollContainerRef.current.scrollTop);
    }

    setSelectedTypeForHistory(doc.type);
    const itemIndexFromAllDocs = tenantDocsData?.findIndex(
      (data) => data?.file_name === doc.file_name
    );
    setSelectedIndex(itemIndexFromAllDocs);
    setDocHistoryPopup(true);
  };

  const getPreviousUploadsForPopup = () => {
    const selectedDoc = tenantDocsData?.[selectedIndex];

    if (selectedDoc?.isDocumentAnalysisBucket) {
      const bucketDocs = Array.isArray(selectedDoc?.bucketDocuments)
        ? selectedDoc.bucketDocuments
        : [];

      const normalizedBucketDocs = bucketDocs.length
        ? bucketDocs
        : selectedDoc?.file_name
          ? [selectedDoc]
          : [];

      return [...normalizedBucketDocs];
      // #NOTE: removed this sorting to show the correct doc in the History
      // .sort(
      //   (a, b) => new Date(b?.created_at) - new Date(a?.created_at),
      // );
    }

    return tenantDocsHistory?.[selectedTypeForHistory] ?? [];
  };

  useEffect(() => {
    if (!docHistoryPopup && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollPosition;
    }
  }, [docHistoryPopup, scrollPosition]);

  const handleDropdownToggle = (section) => {
    // Save scroll position before toggling
    const scrollElement =
      scrollContainerRef.current?.closest(".your-scrollable-parent") ||
      scrollContainerRef.current;

    if (scrollElement) {
      setScrollPosition(scrollElement.scrollTop);
      isTogglingDropdown.current = true;
    }

    // Toggle the dropdown
    setShowDropdown((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getSectionForDocument = (identifiers) => {
    const hasMatch = (documents) =>
      (documents ?? []).some((document) =>
        documentMatchesIdentifiers(document, identifiers)
      );

    // Company login tenants: their groups open by their own key.
    for (const { groupKey, categoryKeys } of COMPANY_TENANT_DOC_GROUPS) {
      const group = forensicDocsMap?.[employmentType]?.[groupKey] ?? {};
      const groupDocs = [
        ...(group?.compulsory ?? []),
        ...(group?.additional ?? []),
      ].flatMap((item) => getDocsForType(item, categoryKeys));
      if (hasMatch(groupDocs)) return groupKey;
    }

    const identificationDocs = (
      forensicDocsMap?.[employmentType]?.identification ?? []
    ).flatMap((item) =>
      getDocsForType(item, [DOCUMENT_CATEGORIES.IDENTIFICATION])
    );
    if (hasMatch(identificationDocs)) return "first";

    const employmentStatus =
      forensicDocsMap?.[employmentType]?.employment_status ?? {};
    const employmentStatusDocs = [
      ...(employmentStatus?.compulsory ?? []),
      ...(employmentStatus?.additional ?? []),
    ].flatMap((item) =>
      getDocsForType(item, [DOCUMENT_CATEGORIES.EMPLOYMENT_STATUS])
    );
    if (hasMatch(employmentStatusDocs)) return "sec";

    const incomeTaxes = forensicDocsMap?.[employmentType]?.income_taxes ?? {};
    const incomeTaxDocs = [
      ...(incomeTaxes?.compulsory ?? []),
      ...(incomeTaxes?.additional ?? []),
    ].flatMap((item) =>
      item?.toLowerCase()?.includes("payslip")
        ? getPayslipDocs()
        : getDocsForType(item, [
            DOCUMENT_CATEGORIES.TAX,
            DOCUMENT_CATEGORIES.INCOME,
            DOCUMENT_CATEGORIES.PAYMENT_RECEIPT,
            DOCUMENT_CATEGORIES.FINANCIAL,
          ])
    );
    if (hasMatch(incomeTaxDocs)) return "third";

    const protectedHousingDocs = getRequiredProtectedHousingDocs().flatMap(
      (item) => getDocsForType(item)
    );
    if (hasMatch(protectedHousingDocs)) return "protectedHousing";

    return "fourth";
  };

  useEffect(() => {
    getSectionForDocumentRef.current = getSectionForDocument;
  });

  useEffect(() => {
    if (!pendingDocumentNavigation || !tenantDocsData?.length) return;
    if (pendingDocumentNavigation.service === "KYC" && !serviceFilesLoaded) {
      return;
    }

    const navigationIdentifiers = new Set(
      pendingDocumentNavigation.identifiers
    );
    if (pendingDocumentNavigation.service === "KYC") {
      getLatestKycServiceFiles(serviceFiles).forEach((serviceFile) => {
        getServiceFileDocumentIdentifiers(serviceFile).forEach((identifier) =>
          navigationIdentifiers.add(identifier)
        );
      });
    }

    const document = tenantDocsData.find((item) =>
      documentMatchesIdentifiers(item, [...navigationIdentifiers])
    );
    if (!document) return;
    const identifiersToHighlight = [...navigationIdentifiers];

    const section = isFromReport
      ? null
      : getSectionForDocumentRef.current?.(identifiersToHighlight);

    console.info("[tenant-document-navigation] document matched", {
      section: section ?? "report list",
      reportMode: isFromReport,
    });

    if (selectedVerdicts.length > 0) {
      setSelectedVerdicts([]);
      return;
    }
    if (section && !showDropdown[section]) {
      setShowDropdown((current) => ({ ...current, [section]: true }));
      return;
    }

    let attempts = 0;
    let frame;
    let retryTimer;
    let cancelled = false;

    const findAndHighlightRow = () => {
      if (cancelled) return;

      const roots = [
        desktopDocumentsRootRef.current,
        mobileDocumentsRootRef.current,
      ].filter(Boolean);
      const visibleRoot =
        roots.find((root) => root.getClientRects().length > 0) ?? roots[0];
      const rows = roots.flatMap((root) =>
        [...root.querySelectorAll("[data-tenant-document-identifiers]")].map(
          (row) => ({ row, isVisible: root.getClientRects().length > 0 })
        )
      );
      const matchesRequest = (row) => {
        try {
          const identifiers = JSON.parse(
            row.dataset.tenantDocumentIdentifiers ?? "[]"
          );
          return identifiersToHighlight.some((identifier) =>
            identifiers.includes(identifier)
          );
        } catch (error) {
          return false;
        }
      };
      const matchingRow = rows.find(
        ({ row: candidate, isVisible }) =>
          isVisible &&
          candidate.getClientRects().length > 0 &&
          matchesRequest(candidate)
      )?.row;

      if (matchingRow) {
        matchingRow.scrollIntoView({ behavior: "smooth", block: "center" });
        setHighlightedDocumentIdentifiers(identifiersToHighlight);
        if (highlightTimeoutRef.current) {
          window.clearTimeout(highlightTimeoutRef.current);
        }
        highlightTimeoutRef.current = window.setTimeout(() => {
          setHighlightedDocumentIdentifiers([]);
          highlightTimeoutRef.current = null;
        }, 8000);

        console.info("[tenant-document-navigation] highlight requested", {
          rowVisible: matchingRow.getClientRects().length > 0,
          rowBounds: (() => {
            const { top, bottom, left, right } =
              matchingRow.getBoundingClientRect();
            return { top, bottom, left, right };
          })(),
          viewport: { width: window.innerWidth, height: window.innerHeight },
        });

        window.requestAnimationFrame(() => {
          const currentRoots = [
            desktopDocumentsRootRef.current,
            mobileDocumentsRootRef.current,
          ].filter(Boolean);
          const renderedRow = currentRoots
            .flatMap((root) => [
              ...root.querySelectorAll("[data-tenant-document-identifiers]"),
            ])
            .find((row) => matchesRequest(row));
          console.info("[tenant-document-navigation] highlight rendered", {
            rowFound: Boolean(renderedRow),
            classApplied: renderedRow?.classList.contains(
              "tenant-document-navigation-highlight"
            ),
            background: renderedRow
              ? window.getComputedStyle(renderedRow).backgroundColor
              : null,
          });
        });
        setPendingDocumentNavigation(null);
        return;
      }

      if (attempts < 10) {
        attempts += 1;
        retryTimer = window.setTimeout(() => {
          frame = window.requestAnimationFrame(findAndHighlightRow);
        }, 50);
        return;
      }

      console.warn("[tenant-document-navigation] row not found", {
        rowCount: rows.length,
        rootCount: roots.length,
        visibleRootFound: Boolean(visibleRoot),
      });
      visibleRoot?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setPendingDocumentNavigation(null);
    };

    frame = window.requestAnimationFrame(findAndHighlightRow);
    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
      window.clearTimeout(retryTimer);
    };
  }, [
    isFromReport,
    pendingDocumentNavigation,
    selectedVerdicts,
    serviceFiles,
    serviceFilesLoaded,
    showDropdown,
    tenantDocsData,
  ]);

  const verdictPriority = {
    HIGH_RISK: 0,
    WARNING: 1,
    SCANNED: 2,
    NORMAL: 3,
    TRUSTED: 4,
  };

  useEffect(() => {
    if (isTogglingDropdown.current) {
      requestAnimationFrame(() => {
        const scrollElement =
          scrollContainerRef.current?.closest(".your-scrollable-parent") ||
          scrollContainerRef.current;

        if (scrollElement && scrollPosition > 0) {
          scrollElement.scrollTop = scrollPosition;
        }

        isTogglingDropdown.current = false;
      });
    }
  }, [showDropdown, scrollPosition]);

  const scannedDocsCount =
    (tenantDocsData ?? []).filter((doc) => {
      if (
        !doc?.isDocumentAnalysisBucket &&
        documentsByType?.[doc?.type]?.file_name !== doc?.file_name
      ) {
        return false;
      }

      const report = forensicDocumentReport?.[doc?.file_name];
      return (
        report?.documentType === "is_scanned_document" ||
        report?.isScannedDocument === "yes"
      );
    }).length || 0;

  const showKycCustomTooltipMessages = (document) => {
    const customMessageData = getKycCustomMessage(user, _t);
    if (
      document?.type
        ?.toLowerCase()
        .includes(customMessageData?.documentType?.toLowerCase()) &&
      document?.from === "others"
    ) {
      return customMessageData;
    }
    return null;
  };

  let processingDocs = tenantDocsDataOriginal?.length
    ? (tenantDocsDataOriginal?.filter(
        (d) => d?.type === "uploaded-from-onboarding"
      ) ?? [])
    : [];

  // Keep latest callbacks in refs so the polling loop never goes stale.
  useEffect(() => {
    fetchFileDataRef.current = fetchFileData;
  });
  useEffect(() => {
    onAnalysisCompleteRef.current = onAnalysisComplete;
  });

  // Poll checkDocumentAnalysisStatus while docs are being analysed so the
  // list refreshes automatically (no manual refresh needed).
  // Starts when processing-type docs appear (or a status check reports
  // processing), stops on done/failed/timeout.
  const tenantIdForPolling = user?._id;
  const hasProcessingDocs = processingDocs?.length > 0;
  const shouldPoll = hasProcessingDocs || analysisStatus === "processing";
  useEffect(() => {
    if (reportMode || isFromReport || !tenantIdForPolling) return;
    if (typeof checkDocumentAnalysisStatus !== "function") return;
    if (!shouldPoll || pollingActiveRef.current) return;

    pollingActiveRef.current = true;
    setAnalysisStatus("processing");
    let cancelled = false;
    let attempts = 0;
    let consecutiveErrors = 0;

    const stopPolling = () => {
      pollingActiveRef.current = false;
      if (pollingTimeoutRef.current) {
        clearTimeout(pollingTimeoutRef.current);
        pollingTimeoutRef.current = null;
      }
    };

    const scheduleNext = () => {
      if (cancelled) return;
      pollingTimeoutRef.current = setTimeout(
        pollOnce,
        ANALYSIS_POLL_INTERVAL_MS
      );
    };

    const finishDone = async (successRes) => {
      if (cancelled) return;
      stopPolling();
      setAnalysisStatus("done");
      try {
        await fetchFileDataRef.current?.();
      } catch {
        // Ignore refetch errors; the docs list keeps its last good state.
      }
      if (cancelled) return;
      onAnalysisCompleteRef.current?.(successRes);
    };

    const finishStopped = (status) => {
      if (cancelled) return;
      stopPolling();
      setAnalysisStatus(status);
    };

    const pollOnce = async () => {
      if (cancelled) return;
      attempts += 1;
      let res = null;
      try {
        res = await checkDocumentAnalysisStatus(tenantIdForPolling);
      } catch {
        consecutiveErrors += 1;
        if (cancelled) return;
        if (consecutiveErrors >= ANALYSIS_MAX_CONSECUTIVE_ERRORS) {
          finishStopped("failed");
          return;
        }
        scheduleNext();
        return;
      }
      if (cancelled) return;
      consecutiveErrors = 0;
      const status = res?.success_res?.status;
      // Only "processing" continues the loop. Every other outcome stops it:
      // "done" refreshes the list, anything else stops silently.
      if (status === "done") {
        await finishDone(res?.success_res);
        return;
      }
      if (status !== "processing" || attempts >= ANALYSIS_MAX_POLL_ATTEMPTS) {
        finishStopped(status === "failed" ? "failed" : "idle");
        return;
      }
      scheduleNext();
    };

    pollOnce();

    return () => {
      cancelled = true;
      stopPolling();
    };
    // Boolean dep avoids restarting the loop on every docs refetch while
    // still processing; it restarts only on idle->processing transitions.
  }, [tenantIdForPolling, shouldPoll, reportMode, isFromReport]);

  // One-shot status check covering the race where analysis is running but
  // processing-type docs haven't appeared in the list yet:
  // - on mount / tenant change (page opened mid-analysis)
  // - when the upload modal closes (updateDoc flow refetches docs once,
  //   which can land before the backend creates processing entries)
  const prevUploadDocModelRef = useRef(uploadDocModel);
  const mountStatusCheckedRef = useRef(null);
  useEffect(() => {
    const wasOpen = prevUploadDocModelRef.current;
    prevUploadDocModelRef.current = uploadDocModel;
    const modalJustClosed = wasOpen === true && uploadDocModel !== true;
    const isNewTenant = mountStatusCheckedRef.current !== tenantIdForPolling;
    if (reportMode || isFromReport || !tenantIdForPolling) return;
    if (typeof checkDocumentAnalysisStatus !== "function") return;
    if (!isNewTenant && !modalJustClosed) return;
    if (shouldPoll || pollingActiveRef.current) {
      mountStatusCheckedRef.current = tenantIdForPolling;
      return;
    }
    mountStatusCheckedRef.current = tenantIdForPolling;
    let cancelled = false;
    (async () => {
      try {
        const res = await checkDocumentAnalysisStatus(tenantIdForPolling);
        if (!cancelled && res?.success_res?.status === "processing") {
          setAnalysisStatus("processing");
        }
      } catch {
        // Ignore: the polling loop treats errors as retryable.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tenantIdForPolling, uploadDocModel, reportMode, isFromReport]);

  // Reset polling state when switching tenants so a new profile starts clean.
  // Only touches status (no timeout clearing) so it can't kill a fresh loop.
  const prevTenantForPollingRef = useRef(tenantIdForPolling);
  useEffect(() => {
    if (prevTenantForPollingRef.current !== tenantIdForPolling) {
      prevTenantForPollingRef.current = tenantIdForPolling;
      setAnalysisStatus("idle");
    }
  }, [tenantIdForPolling]);

  const DocumentLoading = () => {
    return (
      <div className="details-docs__analysing">
        {/* Grey rows shaped like document rows while we analyse */}
        <SkeletonList
          rows={3}
          avatarSize={32}
          label={_t("analysingYourDocuments")}
        />
        <div className="details-docs__analysing-text">
          <p className="details-docs__analysing-title">
            {_t("analysingYourDocuments")}
          </p>
          <p className="details-docs__analysing-subtitle">
            {_t(
              "WeAreProcessingTheNewlyUploadedDocumentationYourProfileWillBeUpdatedAutomaticallyOnceComplete"
            )}
          </p>
          <p className="details-docs__analysing-subtitle">
            {_t("weAreProcessingYour")}{" "}
            <strong>{processingDocs?.length}</strong> {_t("newDocuments")}
          </p>
        </div>
      </div>
    );
  };

  const ScannedTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`scanned-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => (
          <p>{_t("thisSectionContainsScannedDocumentsThatCannotBeAnalyzed")}</p>
        )}
      />
    );
  };

  const MissingDocTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`missing-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => <p>{_t("missingDocTooltipDescription")}</p>}
      />
    );
  };

  const WarningTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`warning-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => <p>{_t("someDocumentsInThisSectionRequireReview")}</p>}
      />
    );
  };

  const HighRiskTooltip = ({ index }) => {
    return (
      <ReactTooltip
        id={`high-risk-doc-icon-${index}`}
        noArrow
        className="react-tooltip-styling details-skor-tooltip"
        render={() => (
          <p>{_t("someDocumentsInThisSectionShowSignsOfTampering")}</p>
        )}
      />
    );
  };

  const MissingDocView = ({ doc }) => (
    <div
      className={`d-flex align-items-center gap-4 justify-content-between BorderB2 py-2 missingDocWrapper${
        missingDocumentsResolved ? " missingDocWrapper--resolved" : ""
      }`}
    >
      <div className="missingDocWrapper__content d-flex align-items-center gap-2">
        <div className="docList docList2">
          <img
            src="/images/red-document-icon.svg"
            alt="Vector Icon"
            className="vactorImg2"
          />
        </div>
        <div className="texReport_div">
          <p>{_t(doc[0], "", "fixed")}</p>
        </div>
      </div>
      {missingDocumentsResolved && (
        <span className="missing-doc-resolved-badge">
          <span aria-hidden="true">✓</span> {_t("resolved", "Resolved")}
        </span>
      )}
    </div>
  );

  const ClaveButton = ({ className }) => (
    <div
      className={`clickBtn2 tooltipButton position-relative d-flex align-items-center gap-2 ${className}`}
    >
      <p>Cl@ve</p>
      <ul className="customTooltip">{_t("claveTooltip")}</ul>
    </div>
  );

  const DocumentView = ({ doc, index }) => (
    <div
      className={`d-flex align-items-center gap-4 justify-content-between BorderB2 ${
        documentMatchesIdentifiers(doc, highlightedDocumentIdentifiers)
          ? "tenant-document-navigation-highlight"
          : ""
      }`}
      data-tenant-document-identifiers={JSON.stringify(
        getTenantDocumentIdentifiers(doc)
      )}
      style={{
        background: index % 2 !== 0 && isFromReport ? "rgb(246, 246, 246)" : "",
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <div className="docList">
          <img src={DocIcon} alt="Vector Icon" className="vactorImg2" />
        </div>
        <div className="texReport_div">
          <p
            className="text-decoration-underline-hover cursor-pointer"
            onClick={() => {
              setDocHistoryPopup(false);
              setSelectedTypeForHistory(doc?.type ?? null);
              setDocHistoryPopup(true);
              setSelectedIndex(index);
            }}
          >
            {haveValue(doc?.bucketName)
              ? doc?.bucketName
              : _t(doc?.type, "", "fixed")}{" "}
            {doc?.type === "Working life certificate" &&
              haveValue(
                forensicAnalysis?.["Work Life Certificate"]?.dataInJSON
                  ?.reportDate
              ) &&
              `(${moment(
                forensicAnalysis?.["Work Life Certificate"]?.dataInJSON
                  ?.reportDate
              ).format("D MMMM YYYY")})`}
          </p>
          {doc && (
            <p className="updatedlist">
              {_t("uploadedOn")} {moment(doc?.created_at).format("DD-MM-YYYY")}
              {isOtherUserDoc(doc) && (
                <span className="uploaddoc">
                  <img src={DotIcon} alt="Vector Icon" className="" />
                  {_t("uploadedFor")} {getDocOwnerLabel(doc)}
                </span>
              )}
            </p>
          )}
          {doc?.from == "clave" && <ClaveButton className="hideOnDesktop" />}
        </div>
      </div>
      <div className="d-flex align-items-center gap-2">
        {doc?.from == "clave" && <ClaveButton className="hideOnMobile" />}
        <div className="d-flex">
          {doc?.verified && (
            <img src={CheckIcon0} alt="Vector Icon" className="vactorImg" />
          )}
        </div>
      </div>
    </div>
  );

  const DocumentFilters = () => {
    const allUploadedDocs = tenantDocsData ?? [];

    // 🔹 Count based on verdicts
    let trustedCount = 0;
    let normalCount = 0;
    let warningCount = 0;
    let highRiskCount = 0;
    let processingDocsCount = 0;
    let scannedCount = 0;

    for (const doc of allUploadedDocs) {
      const docTypeKey = doc?.type;
      const mappedDoc = documentsByType?.[docTypeKey];

      if (
        (!doc?.isDocumentAnalysisBucket &&
          (!mappedDoc || mappedDoc?.file_name !== doc?.file_name) &&
          !docTypeKey?.toLowerCase().includes("payslip")) ||
        docTypeKey === "uploaded-from-onboarding"
      )
        continue;

      const isDeclarationConsent = docTypeKey === "Declaration Consent";
      const verdict = isDeclarationConsent
        ? "NORMAL"
        : forensicDocumentReport?.[doc?.file_name]?.verdict;
      const scannedDoc = isDeclarationConsent
        ? false
        : forensicDocumentReport?.[doc?.file_name]?.documentType ===
            "is_scanned_document" ||
          forensicDocumentReport?.[doc?.file_name]?.isScannedDocument === "yes";
      if (scannedDoc) {
        scannedCount++;
        continue;
      }
      if (verdict === "HIGH_RISK") highRiskCount++;
      else if (verdict === "WARNING") warningCount++;
      else if (verdict === "TRUSTED") trustedCount++;
      else if (verdict === "NORMAL") normalCount++;
      else warningCount++;
    }

    for (const doc of processingDocs) {
      const docTypeKey = doc?.type;
      if (docTypeKey === "uploaded-from-onboarding") {
        processingDocsCount++;
      }
    }

    setAllRenderedDocumentsCount(
      trustedCount +
        normalCount +
        warningCount +
        highRiskCount +
        processingDocsCount +
        scannedCount
    );

    if (llShowOnly) {
      return (
        <div className="details-docs__filters">
          <Tabs
            multiple
            label={_t("documents")}
            items={[
              {
                value: "TRUSTED",
                label: _t("trusted"),
                icon: <Icon name={STATUS_ICONS.trusted.icon} size={16} />,
                tone: STATUS_ICONS.trusted.tone,
                count: trustedCount,
              },
              {
                value: "NORMAL",
                label: _t("normal"),
                icon: <Icon name={STATUS_ICONS.normal.icon} size={16} />,
                tone: STATUS_ICONS.normal.tone,
                count: normalCount,
              },
              {
                value: "WARNING",
                label: _t("warning"),
                icon: <Icon name={STATUS_ICONS.warning.icon} size={16} />,
                tone: STATUS_ICONS.warning.tone,
                count: warningCount,
              },
              {
                value: "HIGH_RISK",
                label: _t("highRisk"),
                icon: <Icon name={STATUS_ICONS.highRisk.icon} size={16} />,
                tone: STATUS_ICONS.highRisk.tone,
                count: highRiskCount,
              },
            ]}
            value={selectedVerdicts}
            onChange={(next) =>
              toggleVerdictFilter(
                next.find((v) => !selectedVerdicts.includes(v)) ??
                  selectedVerdicts.find((v) => !next.includes(v))
              )
            }
          />
        </div>
      );
    } else {
      return;
    }
  };

  const DocumentViewWrapper = ({ isFromDesktop }) => {
    return (
      <>
        <div
          className={`main_doc_div mainDocDivHome details-docs ${
            isFromReport ? "main_doc_div_report_wrapper px-0" : "ds-card"
          } ${isFromDesktop ? "hideOnMobile" : ""}`}
          ref={isFromDesktop ? desktopDocumentsRootRef : mobileDocumentsRootRef}
        >
          <div className={`w-100 ${isFromReport ? "docReportWrapper" : ""}`}>
            <div className={isFromReport ? "docs-padding" : ""}>
              <div
                className={`details-docs__head ${
                  isFromReport ? "BorderB" : ""
                }`.trim()}
              >
                <div className="d-flex align-items-center gap-3 justify-content-center">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <Icon name="fileText" size={20} />
                    <h2 className="ds-card__title">{_t("documents")}</h2>
                    <Badge tone="ink">
                      {isFromReport
                        ? Array.isArray(tenantDocsData)
                          ? tenantDocsData.length
                          : 0
                        : allRenderedDocumentsCount}
                    </Badge>
                    {showLandlordMissingDocNote && visibleMissingDocNote && (
                      <LandlordNotePillButton
                        onScrollToNote={scrollToLandlordMissingDocNote}
                        iconOnly
                      />
                    )}
                    {(() => {
                      if (
                        !processingDocs?.length ||
                        selectedVerdicts.length > 0
                      )
                        return null;

                      return (
                        <div className="position-relative">
                          {llShowOnly && (
                            <Button
                              variant="secondary"
                              size="sm"
                              aria-expanded={!!showDropdown.processing}
                              onClick={() => handleDropdownToggle("processing")}
                              iconEnd={
                                <Icon
                                  name="chevronDown"
                                  size={16}
                                  className={
                                    showDropdown.processing
                                      ? "details-docs__chevron--open"
                                      : ""
                                  }
                                />
                              }
                            >
                              {_t("processingDocuments")}... (
                              {processingDocs?.length})
                            </Button>
                          )}

                          {showDropdown.processing && (
                            <div className="processing-doc-inner-container position-absolute">
                              {processingDocs.map((doc, index) => (
                                <div
                                  key={doc?._id || index}
                                  className="d-flex processing-doc-inner-container-padding justify-content-between position-relative align-items-center"
                                >
                                  <div className="d-flex justify-content-between align-items-center doc-name-wrapper">
                                    <div className="d-flex">
                                      <div className="d-flex align-items-center">
                                        <Icon name="fileText" size={18} />
                                        <div className="process-file-name">
                                          <p className="docName mb-0">
                                            {removeUuidFromFileName(
                                              doc?.file_name
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <Badge tone="neutral">
                                    {_t("classifying")}...
                                  </Badge>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  {/* <div
                  className="d-flex align-items-center gap-2 cursor-pointer"
                  onClick={(e) => handleScrollPending()}
                >
                  <p className="docheader">{_t("pending")}</p>
                  <p className="docnumber docnumberPending">
                    {missingDocs?.length ?? 0}
                  </p>
                </div> */}
                </div>
                <div className="d-flex upload-docs-btn-mobile align-items-center custom-gap-2">
                  {processingDocs?.length === 0 &&
                    !llShowOnly &&
                    !isReadOnly && (
                      <div
                        style={{ display: "inline-block" }}
                        data-tooltip-id={
                          isProfileOutdated
                            ? "upload-docs-blocked-tooltip"
                            : undefined
                        }
                      >
                        <Button
                          variant="secondary"
                          size="sm"
                          className="hideOnMobile"
                          disabled={isProfileOutdated}
                          onClick={() => {
                            if (isProfileOutdated) return;
                            setUploadDocModel(true);
                          }}
                          iconStart={<Icon name="upload" size={16} />}
                        >
                          {_t("updateDocuments")}
                        </Button>
                        <ReactTooltip
                          id="upload-docs-blocked-tooltip"
                          place="top"
                          className="react-tooltip-styling"
                          render={() =>
                            isProfileOutdated ? (
                              <p>
                                {_t(
                                  "profileOutdatedRenewFirst",
                                  "Your profile is outdated. Please renew your profile first."
                                )}
                              </p>
                            ) : null
                          }
                        />
                      </div>
                    )}

                  {llShowOnly && (
                    <Button
                      variant="ghost"
                      size="sm"
                      iconOnly
                      iconStart={<Icon name="download" size={16} />}
                      aria-label={_t("downloadAllDocuments")}
                      title={_t("downloadAllDocuments")}
                      loading={!!showSpinner}
                      onClick={handleZipDown}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              {!isFromReport ? (
                <div>
                  <DocumentFilters />

                  {processingDocs?.length > 0 && !llShowOnly ? (
                    <DocumentLoading />
                  ) : (
                    <div
                      ref={scrollContainerRef}
                      className="mainWrapperForensicDocs"
                    >
                      <div className="documents-container-info"></div>
                      {scannedDocsCount > 0 && llShowOnly ? (
                        <div className="details-docs__scanned">
                          {/* Toggles the "scanned" filter on and off */}
                          <Button
                            variant={
                              selectedVerdicts.includes("SCANNED")
                                ? "primary"
                                : "warning"
                            }
                            size="sm"
                            aria-pressed={selectedVerdicts.includes("SCANNED")}
                            onClick={() => toggleVerdictFilter("SCANNED")}
                            iconStart={
                              <Icon
                                name={STATUS_ICONS.scanned.icon}
                                size={16}
                              />
                            }
                          >
                            {scannedDocsCount}{" "}
                            {_t("documentsCannotBeAnalyzedScannedForImages")}
                          </Button>
                        </div>
                      ) : null}

                      {/* Processing Documents */}

                      {/* Company login tenants: company classification. The
                          sections below render nothing for them (their map
                          has no identification / employment / income group). */}
                      {employmentType === constants.company_tenant &&
                        // Company login tenants: company classification.
                        [
                          {
                            groupKey: "company_identity",
                            icon: "building",
                            categoryKeys: [DOCUMENT_CATEGORIES.BUSINESS],
                            title: _t(
                              "companyIdentity",
                              "Company documents card: group of company identity documents (CIF, incorporation, registry note, beneficial ownership)"
                            ),
                          },
                          {
                            groupKey: "legal_representative",
                            icon: "idCard",
                            categoryKeys: [DOCUMENT_CATEGORIES.IDENTIFICATION],
                            title: _t(
                              "legalRepresentative",
                              "Company documents card: group with the power of attorney and the signatories' ID documents"
                            ),
                          },
                          {
                            groupKey: "company_income_taxes",
                            icon: "wallet",
                            categoryKeys: COMPANY_INCOME_CATEGORIES,
                            title: _t("incomeAndTaxes"),
                          },
                        ].map((group) => (
                          <EmploymentStatusSection
                            key={group.groupKey}
                            groupKey={group.groupKey}
                            dropdownKey={group.groupKey}
                            icon={group.icon}
                            title={group.title}
                            categoryKeys={group.categoryKeys}
                            llShowOnly={llShowOnly}
                            readOnly={isReadOnly}
                            handleDropdownToggle={handleDropdownToggle}
                            showDropdown={showDropdown}
                            forensicDocumentReport={forensicDocumentReport}
                            currentLang={currentLang}
                            isOtherUserDoc={isOtherUserDoc}
                            getDocOwnerLabel={getDocOwnerLabel}
                            getDisplayDocName={getDisplayDocName}
                            setDeleteDocumentConfirmation={
                              setDeleteDocumentConfirmation
                            }
                            setselectedDocument={setselectedDocument}
                            handleViewDocument={handleViewDocument}
                            verdictPriority={verdictPriority}
                            forensicAnalysis={forensicAnalysis}
                            forensicDocsMap={forensicDocsMap}
                            employmentType={employmentType}
                            getDocsForType={getDocsForType}
                            selectedVerdicts={selectedVerdicts}
                            matchesSelectedVerdicts={matchesSelectedVerdicts}
                            getDocServiceTags={getDocServiceTags}
                            highlightedDocumentIdentifiers={
                              highlightedDocumentIdentifiers
                            }
                          />
                        ))}

                      {/* For Identification documents */}
                      <IdentificationSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        showKycCustomTooltipMessages={
                          showKycCustomTooltipMessages
                        }
                        getDocServiceTags={getDocServiceTags}
                        highlightedDocumentIdentifiers={
                          highlightedDocumentIdentifiers
                        }
                      />

                      {/* For Employment status documents */}
                      <EmploymentStatusSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        getDocServiceTags={getDocServiceTags}
                        highlightedDocumentIdentifiers={
                          highlightedDocumentIdentifiers
                        }
                        explainedDocKeys={explainedMissingDocKeys}
                        onViewMissingDocNote={
                          canManageMissingDocNote
                            ? openMissingDocNoteModal
                            : null
                        }
                        onScrollToLandlordNote={
                          showLandlordMissingDocNote
                            ? scrollToLandlordMissingDocNote
                            : null
                        }
                      />

                      {/* For Income taxes documents */}
                      <IncomeTaxesSection
                        allForensicDocuments={allForensicDocuments}
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        getPayslipDocs={getPayslipDocs}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        user={user}
                        getDocServiceTags={getDocServiceTags}
                        highlightedDocumentIdentifiers={
                          highlightedDocumentIdentifiers
                        }
                        explainedDocKeys={explainedMissingDocKeys}
                        onViewMissingDocNote={
                          canManageMissingDocNote
                            ? openMissingDocNoteModal
                            : null
                        }
                        onScrollToLandlordNote={
                          showLandlordMissingDocNote
                            ? scrollToLandlordMissingDocNote
                            : null
                        }
                      />

                      {/* Other documents */}
                      <OtherDocsSection
                        otherDocs={getOtherDocs()}
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        documentsByType={documentsByType}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        forensicAnalysis={forensicAnalysis}
                        getDocServiceTags={getDocServiceTags}
                        highlightedDocumentIdentifiers={
                          highlightedDocumentIdentifiers
                        }
                        showClientIdentificationMissingDoc={
                          showClientIdentificationMissingDoc
                        }
                      />

                      {/* Protected housing documents */}
                      <ProtectedHousingSection
                        llShowOnly={llShowOnly}
                        readOnly={isReadOnly}
                        handleDropdownToggle={handleDropdownToggle}
                        showDropdown={showDropdown}
                        forensicDocumentReport={forensicDocumentReport}
                        currentLang={currentLang}
                        isOtherUserDoc={isOtherUserDoc}
                        getDocOwnerLabel={getDocOwnerLabel}
                        getDisplayDocName={getDisplayDocName}
                        setDeleteDocumentConfirmation={
                          setDeleteDocumentConfirmation
                        }
                        setselectedDocument={setselectedDocument}
                        handleViewDocument={handleViewDocument}
                        verdictPriority={verdictPriority}
                        getRequiredProtectedHousingDocs={
                          getRequiredProtectedHousingDocs
                        }
                        getDocsForType={getDocsForType}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                        getDocServiceTags={getDocServiceTags}
                        highlightedDocumentIdentifiers={
                          highlightedDocumentIdentifiers
                        }
                        explainedDocKeys={explainedMissingDocKeys}
                        onViewMissingDocNote={
                          canManageMissingDocNote
                            ? openMissingDocNoteModal
                            : null
                        }
                        onScrollToLandlordNote={
                          showLandlordMissingDocNote
                            ? scrollToLandlordMissingDocNote
                            : null
                        }
                      />

                      {showLandlordMissingDocNote && visibleMissingDocNote && (
                        <LandlordMissingDocNoteBox
                          note={visibleMissingDocNote}
                          onDocumentClick={scrollToMissingDocRow}
                          translateDocName={(docKey) =>
                            _t(
                              modalMissingDocLabelByKey.get(docKey) ?? docKey,
                              "",
                              "fixed"
                            )
                          }
                        />
                      )}

                      <NoDocumentsFound
                        forensicDocsMap={forensicDocsMap}
                        employmentType={employmentType}
                        getDocsForType={getDocsForType}
                        getPayslipDocs={getPayslipDocs}
                        getRequiredProtectedHousingDocs={
                          getRequiredProtectedHousingDocs
                        }
                        getOtherDocs={getOtherDocs}
                        selectedVerdicts={selectedVerdicts}
                        matchesSelectedVerdicts={matchesSelectedVerdicts}
                      />
                    </div>
                  )}
                </div>
              ) : (
                docsToRender?.map((doc, index) =>
                  isFromReport && doc?.type === "missing" ? (
                    <MissingDocView doc={doc} key={index} />
                  ) : (
                    <DocumentView doc={doc} index={index} key={index} />
                  )
                )
              )}
            </div>
          </div>
          {isFromReport && (
            <div
              className={`${
                missingDocs.length > 0
                  ? "bgclolr_change custom-mt-3"
                  : "missing_doc bgclolr_change custom-mt-3"
              }`}
              id="missingDocs"
            >
              {isFromReport &&
                reportDocsSecondHalf?.map((doc, index) =>
                  doc.type === "missing" ? (
                    <>
                      <MissingDocView doc={doc} key={index} />
                    </>
                  ) : (
                    <>
                      <DocumentView doc={doc} index={index} key={index} />
                    </>
                  )
                )}
              {!isFromReport && missingDocs?.length > 0 && (
                <div className="d-flex align-items-center gap-2 BorderB2">
                  <img
                    src={noticIcon}
                    alt="Vector Icon"
                    className="vactorImg2"
                  />
                  <p className="docheader">{_t("missingDocuments")}</p>
                </div>
              )}
              {!isFromReport && (
                <div
                  className={`documents_fixed
                              ${
                                isFromReport
                                  ? "fullHeightReport"
                                  : missingDocs?.length > 12 &&
                                      tenantDocsData?.length === 0
                                    ? "greeterThenTenHeight"
                                    : missingDocs?.length > 5 &&
                                        tenantDocsData?.length === 0
                                      ? "greeterThenFiveHeight"
                                      : missingDocs?.length > 5 &&
                                          tenantDocsData?.length > 5
                                        ? "bothGreaterThenFive"
                                        : "lessThenFiveHeight"
                              }`}
                >
                  {Object.entries(mandatoryDocsList)?.map(([key, value]) => {
                    const isPayslipKey = key.toLowerCase().includes("payslip");

                    if (hasModel100Fallback(key)) return null;

                    // Slot-aware for 3-payslip employment types, else doc count.
                    const useSlots =
                      isThreePayslipRequiredHere &&
                      Object.keys(mandatoryDocsList).some((k) =>
                        k.toLowerCase().includes("payslip")
                      );
                    const payslipSatisfiedCount = useSlots
                      ? payslipSlotInfo.filled
                      : getPayslipUploadedCount(tenantDocsHistory);

                    if (isPayslipKey) {
                      const index = PAYSLIP_ORDER.indexOf(key);

                      if (index !== -1) {
                        if (index < payslipSatisfiedCount) {
                          return null;
                        }
                      } else {
                        if (useSlots) {
                          // Generic key expanded: satisfied only when all 3
                          // slots are filled.
                          if (payslipSatisfiedCount >= 3) {
                            return null;
                          }
                        } else {
                          const needed =
                            key.toLowerCase() === "last 3 payslips" ? 3 : 1;
                          if (payslipSatisfiedCount >= needed) {
                            return null;
                          }
                        }
                      }
                    }

                    // normal missing document check
                    if (!(key in tenantDocsHistory && !isPayslipKey)) {
                      // An explained document stays missing, but the tenant
                      // sees a "View note" button instead of the warning icon.
                      // Landlord views show a read-only pill scrolling to the
                      // note box at the end of Documentos.
                      const rowShowsNoteButton =
                        canManageMissingDocNote &&
                        isMissingDocExplained(key, missingDocNote);
                      const rowShowsNotePill =
                        showLandlordMissingDocNote &&
                        isMissingDocExplained(key, missingDocNote);
                      return (
                        <div
                          key={key}
                          id={
                            rowShowsNotePill
                              ? getMissingDocRowAnchorId(key)
                              : undefined
                          }
                          className="d-flex align-items-center gap-4 justify-content-between BorderB2 py-2 missingDocWrapper"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div className="docList docList2">
                              <img
                                src="/images/red-document-icon.svg"
                                alt="Vector Icon"
                                className="vactorImg2"
                              />
                            </div>
                            <div className="texReport_div">
                              <p>{_t(key, "", "fixed")}</p>
                            </div>
                          </div>
                          {rowShowsNoteButton && (
                            <ViewMissingDocNoteButton
                              onViewNote={openMissingDocNoteModal}
                            />
                          )}
                          {rowShowsNotePill && (
                            <LandlordNotePillButton
                              onScrollToNote={scrollToLandlordMissingDocNote}
                            />
                          )}
                        </div>
                      );
                    }

                    return null;
                  })}
                </div>
              )}
            </div>
          )}
          {processingDocs?.length === 0 && analysisStatus !== "processing" && (
            <MissingDocNoteFooter
              canManage={canManageMissingDocNote}
              missingDocsCount={missingDocs?.length ?? 0}
              explainedCount={
                visibleMissingDocNote?.explainedDocuments?.length ?? 0
              }
              onEdit={openMissingDocNoteModal}
            />
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className={`${
          isFromReport ? "col-md-12" : "col-md-6"
        } custom-items--stretch ${topContent ? "details-docs__column--stack" : ""}`}
      >
        {topContent}
        <DocumentViewWrapper isFromDesktop={true} />
        {docModel && (
          <div
            className="popup-overlay fixed inset-0 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen guarantorBg documentViewModal"
            onClick={() => setDocModel(false)}
          >
            <div
              className="contentMainWrapper"
              onClick={(e) => e.stopPropagation()}
            >
              <span className="drawerIcon" onClick={() => setDocModel(false)} />
              <div className="col-md-6 custom-items--stretch">
                <DocumentViewWrapper />
              </div>
              {!llShowOnly && (
                <Button
                  size="lg"
                  iconStart={
                    <img src="/images/updateDocumentsIcon.svg" alt="" />
                  }
                  onClick={() => setUploadDocModel(true)}
                >
                  {_t("updateDocuments")}
                </Button>
              )}
            </div>
          </div>
        )}
        <DocHistoryPopup
          isOpen={docHistoryPopup}
          user={user}
          onClose={() => {
            setDocHistoryPopup(false);
            setSelectedIndex(0);
          }}
          docName={selectedTypeForHistory}
          allData={tenantDocsData}
          previousUploads={getPreviousUploadsForPopup()}
          handlePreviewDocument={handlePreviewDocument}
          selectedIndex={selectedIndex}
          allForensicDocuments={allForensicDocuments}
          currentLang={currentLang}
          hideDownload={isReadOnly}
        />
        {!llShowOnly && (
          <DocUploadingComponentWithAnalysing
            isOpen={uploadDocModel}
            onClose={() => setUploadDocModel(false)}
            user={user}
            fetchFileDataParent={fetchFileData}
            isGuarantor={isGuarantor}
          />
        )}
        {missingDocNoteModalOpen && (
          <MissingDocumentsNoteModal
            missingDocuments={modalMissingDocOptions.map(
              (option) => option.key
            )}
            initialNote={missingDocNote}
            onSave={handleSaveMissingDocNote}
            onClose={() => setMissingDocNoteModalOpen(false)}
            translateDocName={(docKey) =>
              _t(modalMissingDocLabelByKey.get(docKey) ?? docKey, "", "fixed")
            }
          />
        )}
      </div>
      <Button
        variant="primary"
        size="lg"
        className={`myDocsFab ${isSkorSdkSearch() ? "isSkorSdkDocumentMode" : ""}`}
        iconStart={<Icon name="fileText" size={20} />}
        iconEnd={<Icon name="chevronRight" size={16} />}
        onClick={() => setDocModel(true)}
      >
        {_t("myDocuments")}
      </Button>
      <DeleteConfirationForDoc
        isOpen={deleteDocumentConfirmation}
        onClose={() => setDeleteDocumentConfirmation(false)}
        name={_t(selectedDocument?.type, "", "fixed") ?? ""}
        heading={_t("deleteDocument")}
        description={_t("areYouSureDoYouWantToDeleteThisDocument")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setDeleteDocumentConfirmation(false)}
        btn2Functionality={() => handleDeleteDocument(selectedDocument?._id)}
        submitLoading={deleteDocumentLoading}
      />
    </>
  );
};
export default DetailsDocs;
